import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../providers/AuthProvider'

export default function BottomNav() {
    const location = useLocation()
    const currentPath = location.pathname
    const { user, role } = useAuth()

    // 역할에 따른 "구인구직" 링크 결정
    const jobLink = role === 'pharmacy' ? '/pharmacy' : '/pharmacist' // 약국이면 내 공고/관리, 약사면 찾기
    // 비로그인이면 기본 약사 페이지(공고 리스트)로
    const targetJobLink = !user ? '/pharmacist' : jobLink

    const myPageLink = !user
        ? '/login'
        : role === 'pharmacy'
            ? '/mypage/pharmacy'
            : role === 'pharmacist'
                ? '/mypage/pharmacist'
                : '/admin'

    const isActive = (path) => currentPath === path || currentPath.startsWith(path + '/')

    return (
        <nav className="fixed bottom-0 w-full max-w-lg bg-white border-t border-gray-100 flex justify-around items-center h-16 pb-1 z-50 text-[10px] text-gray-400 font-medium">
            <Link
                to="/"
                className={`flex flex-col items-center justify-center w-full h-full ${isActive('/') && currentPath === '/' ? 'text-blue-600' : 'hover:text-gray-600'
                    }`}
            >
                <svg className="w-6 h-6 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                <span>홈</span>
            </Link>

            <Link
                to={role === 'pharmacy' ? '/pharmacy' : '/jobs'}
                className={`flex flex-col items-center justify-center w-full h-full ${isActive('/pharmacy') || isActive('/jobs') ? 'text-blue-600' : 'hover:text-gray-600'
                    }`}
            >
                <svg className="w-6 h-6 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {role === 'pharmacy' ? (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                    ) : (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    )}
                </svg>
                <span>{role === 'pharmacy' ? '공고관리' : '구인구직'}</span>
            </Link>

            <Link
                to={myPageLink}
                className={`flex flex-col items-center justify-center w-full h-full ${isActive('/mypage') || isActive('/login') ? 'text-blue-600' : 'hover:text-gray-600'
                    }`}
            >
                <svg className="w-6 h-6 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span>마이페이지</span>
            </Link>
        </nav >
    )
}
